import { createContext, useContext, useCallback } from "react";
import useApiService from "./ApiService";
import CONFIG from "./CONFIG";

const PromptApiContext = createContext(null);

export function PromptApiProvider({ children }) {
    const { get, put, del } = useApiService(CONFIG.SERVER_ASSISTANT);

    const getPrompts = useCallback(async (skip, limit) => {
        if (!skip) {
            skip = 0;
        }
        if (!limit) {
            limit = 10;
        }
        try {
            const response = await get(`/v1/prompts?skip=${skip}&limit=${limit}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching prompts:", error);
            throw error;
        }
    }, [get]);

    const getPromptById = useCallback(async (promptId) => {
        try {
            const response = await get(`/v1/prompts/${promptId}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching prompt by ID:", error);
            throw error;
        }
    }, [get]);

    const createPrompt = useCallback(async (prompt) => {
        try {
            const response = await put(`/v1/prompts`, prompt);
            return response.data;
        } catch (error) {
            console.error("Error creating prompt:", error);
            throw error;
        }
    }, [put]);

    const updatePrompt = useCallback(async (promptId, prompt) => {
        try {
            const response = await put(`/v1/prompts/${promptId}`, prompt);
            return response.data;
        } catch (error) {
            console.error("Error updating prompt:", error);
            throw error;
        }
    }, [put]);

    const deletePrompt = useCallback(async (promptId) => {
        try {
            const response = await del(`/v1/prompts/${promptId}`);
            return response.data;
        } catch (error) {
            console.error("Error deleting prompt:", error);
            throw error;
        }
    }
    , [del]);

    return (
        <PromptApiContext.Provider value={{ getPrompts, getPromptById, createPrompt, updatePrompt, deletePrompt }}>
            {children}
        </PromptApiContext.Provider>
    );
}

export function usePromptApi() {
    const context = useContext(PromptApiContext);
    if (!context) {
        throw new Error("usePromptApi must be used within a PromptApiProvider");
    }
    return context;
}